"use strict";

export let PointerType = /*#__PURE__*/function (PointerType) {
  PointerType[PointerType["TOUCH"] = 0] = "TOUCH";
  PointerType[PointerType["STYLUS"] = 1] = "STYLUS";
  PointerType[PointerType["MOUSE"] = 2] = "MOUSE";
  PointerType[PointerType["KEY"] = 3] = "KEY";
  PointerType[PointerType["OTHER"] = 4] = "OTHER";
  return PointerType;
}({});
//# sourceMappingURL=PointerType.js.map